import React, { useEffect } from 'react';
import { ChevronDown, ChevronRight } from 'react-feather';
import SideEnds from './SideEnds';

export default function PricePreview({
	sections,
	selectedStyle,
	toggleSection,
	totalEstimate,
	discount,
	totalLegPrice,
	cSHeight,
	cSLength,
	cSWidth,
	totalCenterLegPrice,
	totalRoofStylePrice,
	totalRoofPitchPrice,
	selectedRoofStyle,
	selectedRoofPitch,
	installationSurface,
	colors,
	subTotal,
	totalDiscount,
	taxRate,
	doorWindowSelections,
	formAdditionalOptionsData,
	// Structure Gauge prices
	totalCenterGauge,
	// Left lean-to
	lLWidth,
	lLLength,
	lLHeight,
	leftLeanPrice,
	totalLeftLegPrice,
	leftSideRoofPitchPrice,
	// Right lean-to
	rLWidth,
	rLLength,
	rLHeight,
	rightLeanPrice,
	totalRightLegPrice,
	rightSideRoofPitchPrice,
	// Front lean-to
	fLWidth,
	fLLength,
	fLHeight,
	frontLeanPrice,
	totalFrontLegPrice,
	frontRoofPitchPrice,
	// Back lean-to
	bLWidth,
	bLLength,
	bLHeight,
	backLeanPrice,
	totalBackLegPrice,
	backRoofPitchPrice,
	// Wall prices
	sidewallCosts,
	// Totals
	onValuesWallsChange,
	sideWallSidingPanels,
	sideWallSidingPanelsData,
	// object with configuration
	sideEndData,
	// Installation fee
	installationFee,
	insulationPriceBreakdown,
	// Storage
	centerStorage,
	dephCentralStorage,
	centerStoragePrice,
	leftLean,
	dephLeftStorage,
	leftleanstoragePrice,
	rightLean,
	dephRightStorage,
	rightStoragePrice,
	frontLean,
	dephFrontStorage,
	frontStoragePrice,
	backLean,
	dephBackStorage,
	backStoragePrice,
	storagePanelsTotal,
	storagePanelsBreakdown,
	// Additional options prices
	panelUpgradePrice,
	anchorsTotalPrice,
	bracingTotalPrice,
	autoBracingTotalPrice = 0,
	autoBracingCount = 0,
	trussesTotalPrice,
	texasCutTotal,
	foamClosureTotal = 0,
	engineeringPlansFee = 0,
}) {
	// this is the tax rate value Object { state_rate: "0.060000" } state_rate: "0.060000" how to take the value of state_rate
	const taxRateValue = taxRate?.state_rate || 0.0725;
	// convert the tax rate value to a number with 2 decimal places the rate is 0.060000 I need to display 6.0

	const taxRateDisplay = taxRate?.state_rate * 100 || 0.0725;

	const installationFeeAmount = (subTotal * installationFee) / 100;
	const taxes = subTotal * taxRateValue;
	const total = subTotal + installationFeeAmount + taxes + engineeringPlansFee;

	// Helper to format price or show included
	const formatPrice = (price) => {
		if (price === 0 || price === '0' || !price) {
			return <span className="text-slate-400 italic">Included</span>;
		}
		return `$${price.toLocaleString('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		})}`;
	};

	// Helper for structural items (Base, Lean-tos) - warn if missing
	const formatStructuralPrice = (price) => {
		if (!price || price === 0 || price === '0') {
			return <span className="text-red-500 font-bold">Price Not Found</span>;
		}
		return formatPrice(price);
	};

	// console.log('sideWallSidingPanels', sideWallSidingPanels);
	// console.log('sideEndData', sideEndData);

	// reload when sidewallcosts changes
	useEffect(() => {
		console.log('sidewallCosts', sidewallCosts);
	}, [sidewallCosts]);

	const centerSectionSide = sidewallCosts?.centerSectionSide || {};
	const leftLeanTo = sidewallCosts?.leftLeanToSide || {};
	const rightLeanTo = sidewallCosts?.rightLeanToSide || {};
	const backLeanTo = sidewallCosts?.backLeanToSide || {};
	const frontLeanTo = sidewallCosts?.frontLeanToSide || {};
	const centerSectionLeftSideWall = centerSectionSide?.leftSidewall || 0;
	const centerSectionRightSideWall = centerSectionSide?.rightSidewall || 0;
	const centerSectionFrontGableEnd = centerSectionSide?.frontGableEnd || 0;
	const centerSectionBackGableEnd = centerSectionSide?.backGableEnd || 0;
	const leftLeanToLeftSideWall = leftLeanTo?.leftSidewall || 0;
	const leftLeanToRightSideWall = leftLeanTo?.rightSidewall || 0;
	const leftLeanToFrontGableEnd = leftLeanTo?.frontGableEnd || 0;
	const leftLeanToBackGableEnd = leftLeanTo?.backGableEnd || 0;
	const rightLeanToLeftSideWall = rightLeanTo?.leftSidewall || 0;
	const rightLeanToRightSideWall = rightLeanTo?.rightSidewall || 0;
	const rightLeanToFrontGableEnd = rightLeanTo?.frontGableEnd || 0;
	const rightLeanToBackGableEnd = rightLeanTo?.backGableEnd || 0;
	const backLeanToLeftSideWall = backLeanTo?.leftSidewall || 0;
	const backLeanToRightSideWall = backLeanTo?.rightSidewall || 0;
	const backLeanToFrontGableEnd = backLeanTo?.frontGableEnd || 0;
	const backLeanToBackGableEnd = backLeanTo?.backGableEnd || 0;
	const frontLeanToLeftSideWall = frontLeanTo?.leftSidewall || 0;
	const frontLeanToRightSideWall = frontLeanTo?.rightSidewall || 0;
	const frontLeanToFrontGableEnd = frontLeanTo?.frontGableEnd || 0;
	const frontLeanToBackGableEnd = frontLeanTo?.backGableEnd || 0;

	const wallstotal =
		centerSectionLeftSideWall +
		centerSectionRightSideWall +
		centerSectionFrontGableEnd +
		centerSectionBackGableEnd +
		leftLeanToLeftSideWall +
		leftLeanToRightSideWall +
		leftLeanToFrontGableEnd +
		leftLeanToBackGableEnd +
		rightLeanToLeftSideWall +
		rightLeanToRightSideWall +
		rightLeanToFrontGableEnd +
		rightLeanToBackGableEnd +
		backLeanToLeftSideWall +
		backLeanToRightSideWall +
		backLeanToFrontGableEnd +
		backLeanToBackGableEnd +
		frontLeanToLeftSideWall +
		frontLeanToRightSideWall +
		frontLeanToFrontGableEnd +
		frontLeanToBackGableEnd;

	useEffect(() => {
		onValuesWallsChange(wallstotal);
	}, [wallstotal, onValuesWallsChange]);

	// Destructure configuration and costs from sideEndData
	const {
		configuration: {
			// centerSectionSide = {},
			backLeanToSide = {},
			leftLeanToSide = {},
			frontLeanToSide = {},
			rightLeanToSide = {},
		} = {},
		costs: {
			centerSectionSide: centerCosts = {},
			backLeanToSide: backCosts = {},
			leftLeanToSide: leftCosts = {},
			frontLeanToSide: frontCosts = {},
			rightLeanToSide: rightCosts = {},
		} = {},
	} = sideEndData || {};

	// A map of raw values to the labels you want to display.
	const sideEndLabels = {
		open: 'Open',
		0: 'Open', // Handles cases where 'Open' is stored as the string '0'
		fullyEnclosed: 'Fully Enclosed',
		gableEnd: 'Gable End',
		extendedGableEnd: 'Extended Gable End',
		gableEndWall6: 'Gable End Wall 6',
		leftSideEnclosed: 'Left Side Enclosed',
		rightSideEnclosed: 'Right Side Enclosed',
		leftSideWithGableEnd: 'Left Side With Gable End',
		rightSideWithGableEnd: 'Right Side with Gable End',
	};
	const getSideEndLabel = (value, fallback = 'Open') => {
		return sideEndLabels[value] || value || fallback;
	};

	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div className="user-information">
					<>
						<div
							className="title-block"
							onClick={(e) => toggleSection('client', e)}
						>
							<h2 className="title-h2">Price Summary</h2>
							<button>
								{sections.client ? (
									<ChevronDown size={24} />
								) : (
									<ChevronRight size={24} />
								)}
							</button>
						</div>
						{sections.client && (
							<div className="price-cont">
								<table className="price-summary">
									<tbody>
										{/* ============================ */}
										<tr>
											<th className="title-tr">BASE</th>
										</tr>
										<tr>
											<td>
												<strong>{selectedStyle}</strong>
											</td>
											<td>
												{cSWidth}‘W x {cSLength}‘L x {cSHeight}‘H
											</td>
										</tr>

										<tr>
											<td>
												<strong>Installation Surface:</strong>{' '}
											</td>
											<td>{installationSurface}</td>
										</tr>

										<tr>
											<td>
												<strong>Roof Style:</strong>
											</td>
											<td>{selectedRoofStyle}</td>
										</tr>

										<tr>
											<th className="title-tr">CENTER BUILDING</th>
										</tr>
										<tr>
											<td>
												<strong>Base Price:</strong> {cSWidth}‘W x {cSLength}‘L
											</td>
											<td>
												{formatStructuralPrice(totalCenterGauge)}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Height</strong> {cSHeight}‘H
											</td>
											<td>
												{formatPrice(totalCenterLegPrice)}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Roof Style:</strong>
												{selectedRoofStyle ? ` ${selectedRoofStyle}` : ''}
											</td>
											<td>
												{formatPrice(totalRoofStylePrice)}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Roof Pitch:</strong>
												{selectedRoofPitch ? ` ${selectedRoofPitch}` : ''}
											</td>
											<td>
												{formatPrice(totalRoofPitchPrice)}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Roof Overhang:</strong> Standard
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>Trusses:</strong> Standard
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>Gauge:</strong>{' '}
												{formAdditionalOptionsData?.frameGauge === '2' ? '12-Gauge Framing' : '14-Gauge Framing'}
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>Brace:</strong> Standard Brace
											</td>
											<td>-</td>
										</tr>

										{/* Center Building Walls moved here */}
										<tr>
											<td>
												<strong>Front End:</strong>{' '}
												{getSideEndLabel(
													sideEndData?.configuration?.centerSectionSide
														?.frontGableEnd
												)}
											</td>
											<td>
												{formatPrice(centerCosts.frontGableEnd)}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Back End:</strong>{' '}
												{getSideEndLabel(
													sideEndData?.configuration?.centerSectionSide
														?.backGableEnd
												)}
											</td>
											<td>
												{formatPrice(centerCosts.backGableEnd)}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Right Side Wall:</strong>{' '}
												{getSideEndLabel(
													sideEndData?.configuration?.centerSectionSide
														?.rightSidewall
												)}
											</td>
											<td>
												{formatPrice(centerCosts.rightSidewall)}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Left Side Wall:</strong>{' '}
												{getSideEndLabel(
													sideEndData?.configuration?.centerSectionSide
														?.leftSidewall
												)}
											</td>
											<td>
												{formatPrice(centerCosts.leftSidewall)}
											</td>
										</tr>

										{/* ============================ */}
										{/* RIGHT LEAN-TO */}
										{rLWidth && (
											<>
												<tr>
													<th className="title-tr">RIGHT LEAN-TO</th>
												</tr>

												{/* Size row */}
												<tr>
													<td>
														<strong>Size:</strong> {rLWidth}‘W x {rLLength}‘L
													</td>
													<td>
														{formatStructuralPrice(rightLeanPrice)}
													</td>
												</tr>

												{/* Height row */}
												<tr>
													<td>
														<strong>Height:</strong> {rLHeight}‘H
													</td>
													<td>
														{formatPrice(totalRightLegPrice)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Roof Pitch:</strong>
														{sideEndData?.configuration?.rightLeanToSide
															?.rightLeanRoofPitch
															? ` ${sideEndData?.configuration?.rightLeanToSide?.rightLeanRoofPitch}`
															: ''}
													</td>
													<td>
														{formatPrice(rightSideRoofPitchPrice)}
													</td>
												</tr>

												<tr>
													<td>
														<strong>Front End:</strong>{' '}
														{getSideEndLabel(
															sideEndData?.configuration?.rightLeanToSide
																?.frontGableEnd
														)}
													</td>
													<td>
														{formatPrice(rightCosts.frontGableEnd)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Back End:</strong>{' '}
														{getSideEndLabel(
															sideEndData?.configuration?.rightLeanToSide
																?.backGableEnd
														)}
													</td>
													<td>
														{formatPrice(rightCosts.backGableEnd)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Right Side Wall:</strong>{' '}
														{getSideEndLabel(rightLeanToSide?.rightSidewall)}
													</td>
													<td>
														{formatPrice(rightCosts.rightSidewall)}
													</td>
												</tr>
											</>
										)}

										{/* ============================ */}
										{/* LEFT LEAN-TO */}
										{lLWidth && (
											<>
												<tr>
													<th className="title-tr">LEFT LEAN-TO</th>
												</tr>

												{/* Size row */}
												<tr>
													<td>
														<strong>Size:</strong> {lLWidth}‘W x {lLLength}‘L
													</td>
													<td>
														{formatStructuralPrice(leftLeanPrice)}
													</td>
												</tr>

												{/* Height row */}
												<tr>
													<td>
														<strong>Height:</strong> {lLHeight}‘H
													</td>
													<td>
														{formatPrice(totalLeftLegPrice)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Roof Pitch:</strong>
														{sideEndData?.configuration?.leftLeanToSide
															?.leftLeanRoofPitch
															? ` ${sideEndData?.configuration?.leftLeanToSide?.leftLeanRoofPitch}`
															: ''}
													</td>
													<td>
														{formatPrice(leftSideRoofPitchPrice)}
													</td>
												</tr>

												<tr>
													<td>
														<strong>Front End:</strong>{' '}
														{getSideEndLabel(
															sideEndData?.configuration?.leftLeanToSide
																?.frontGableEnd
														)}
													</td>
													<td>
														{formatPrice(leftCosts.frontGableEnd)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Back End:</strong>{' '}
														{getSideEndLabel(
															sideEndData?.configuration?.leftLeanToSide
																?.backGableEnd
														)}
													</td>
													<td>
														{formatPrice(leftCosts.backGableEnd)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Left Side Wall:</strong>{' '}
														{getSideEndLabel(leftLeanToSide?.leftSidewall)}
													</td>
													<td>
														{formatPrice(leftCosts.leftSidewall)}
													</td>
												</tr>
											</>
										)}

										{/* ============================ */}
										{/* BACK LEAN-TO */}
										{bLWidth && (
											<>
												<tr>
													<th className="title-tr">BACK LEAN-TO</th>
												</tr>

												{/* Size row */}
												<tr>
													<td>
														<strong>Size:</strong> {bLWidth}‘W x {bLLength}‘L
													</td>
													<td>
														{formatStructuralPrice(backLeanPrice)}
													</td>
												</tr>

												{/* Height row */}
												<tr>
													<td>
														<strong>Height:</strong> {bLHeight}‘H
													</td>
													<td>
														{formatPrice(totalBackLegPrice)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Roof Pitch:</strong>
														{sideEndData?.configuration?.backLeanToSide
															?.backLeanRoofPitch
															? ` ${sideEndData?.configuration?.backLeanToSide?.backLeanRoofPitch}`
															: ''}
													</td>
													<td>
														{formatPrice(backRoofPitchPrice)}
													</td>
												</tr>

												<tr>
													<td>
														<strong>Front End:</strong>{' '}
														{getSideEndLabel(
															sideEndData?.configuration?.backLeanToSide
																?.frontGableEnd
														)}
													</td>
													<td>
														{formatPrice(backCosts.frontGableEnd)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Back End:</strong>{' '}
														{getSideEndLabel(
															sideEndData?.configuration?.backLeanToSide
																?.backGableEnd
														)}
													</td>
													<td>
														{formatPrice(backCosts.backGableEnd)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Right Side Wall:</strong>{' '}
														{getSideEndLabel(backLeanToSide?.rightSidewall)}
													</td>
													<td>
														{formatPrice(backCosts.rightSidewall)}
													</td>
												</tr>
											</>
										)}

										{/* ============================ */}
										{/* FRONT LEAN-TO */}
										{fLWidth && (
											<>
												<tr>
													<th className="title-tr">FRONT LEAN-TO</th>
												</tr>

												{/* Size row */}
												<tr>
													<td>
														<strong>Size:</strong> {fLWidth}‘W x {fLLength}‘L
													</td>
													<td>
														{formatStructuralPrice(frontLeanPrice)}
													</td>
												</tr>

												{/* Height row */}
												<tr>
													<td>
														<strong>Height:</strong> {fLHeight}‘H
													</td>
													<td>
														{formatPrice(totalFrontLegPrice)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Roof Pitch:</strong>
														{sideEndData?.configuration?.frontLeanToSide
															?.frontLeanRoofPitch
															? ` ${sideEndData?.configuration?.frontLeanToSide?.frontLeanRoofPitch}`
															: ''}
													</td>
													<td>
														{formatPrice(frontRoofPitchPrice)}
													</td>
												</tr>

												<tr>
													<td>
														<strong>Front End:</strong>{' '}
														{getSideEndLabel(frontLeanToSide?.frontGableEnd)}
													</td>
													<td>
														{formatPrice(frontCosts.frontGableEnd)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Back End:</strong>{' '}
														{getSideEndLabel(
															sideEndData?.configuration?.frontLeanToSide
																?.backGableEnd
														)}
													</td>
													<td>
														{formatPrice(frontCosts.backGableEnd)}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Left Side Wall:</strong>{' '}
														{getSideEndLabel(frontLeanToSide?.leftSidewall)}
													</td>
													<td>
														{formatPrice(frontCosts.leftSidewall)}
													</td>
												</tr>
											</>
										)}

										{/* ============================ */}
										{/* STORAGE */}
										{(
											(centerStorage && centerStorage !== 'none') ||
											leftLean === 'leanToWithStorage' ||
											rightLean === 'leanToWithStorage' ||
											frontLean === 'leanToWithStorage' ||
											backLean === 'leanToWithStorage'
										) && (
											<>
												<tr>
													<th className="title-tr">STORAGE</th>
												</tr>

												{/* Storage sections — individual wall breakdown per section */}
												{(() => {
													const renderStorageSection = (sectionKey, label, width, depth, height, basePrice) => {
														const walls = storagePanelsBreakdown?.[sectionKey];
														return (
															<React.Fragment key={sectionKey}>
																<tr>
																	<td><strong>{label}:</strong> {width}'W &times; {depth}'D &times; {height}'H</td>
																	<td>{formatStructuralPrice(basePrice)}</td>
																</tr>
																{walls?.dividingWall > 0 && (
																	<tr>
																		<td>&nbsp;&nbsp;Dividing Wall</td>
																		<td>{formatPrice(walls.dividingWall)}</td>
																	</tr>
																)}
																{walls?.backWall > 0 && (
																	<tr>
																		<td>&nbsp;&nbsp;Back End <span className="text-slate-400 italic">(open)</span></td>
																		<td>{formatPrice(walls.backWall)}</td>
																	</tr>
																)}
																{walls?.leftSide > 0 && (
																	<tr>
																		<td>&nbsp;&nbsp;Left Side <span className="text-slate-400 italic">(open)</span></td>
																		<td>{formatPrice(walls.leftSide)}</td>
																	</tr>
																)}
																{walls?.rightSide > 0 && (
																	<tr>
																		<td>&nbsp;&nbsp;Right Side <span className="text-slate-400 italic">(open)</span></td>
																		<td>{formatPrice(walls.rightSide)}</td>
																	</tr>
																)}
															</React.Fragment>
														);
													};
													return (
														<>
															{centerStorage && centerStorage !== 'none' &&
																renderStorageSection('centerStorage', 'Center Storage', cSWidth, dephCentralStorage, cSHeight, centerStoragePrice)}
															{leftLean === 'leanToWithStorage' &&
																renderStorageSection('leftStorage', 'Left Storage', lLWidth, dephLeftStorage, lLHeight, leftleanstoragePrice)}
															{rightLean === 'leanToWithStorage' &&
																renderStorageSection('rightStorage', 'Right Storage', rLWidth, dephRightStorage, rLHeight, rightStoragePrice)}
															{frontLean === 'leanToWithStorage' &&
																renderStorageSection('frontStorage', 'Front Storage', fLWidth, dephFrontStorage, fLHeight, frontStoragePrice)}
															{backLean === 'leanToWithStorage' &&
																renderStorageSection('backStorage', 'Back Storage', bLWidth, dephBackStorage, bLHeight, backStoragePrice)}
														</>
													);
												})()}
											</>
										)}

										{/* ============================ */}
										<tr>
											<th className="title-tr">COLORS</th>
										</tr>
										<tr>
											<td>
												<strong>Roof Color:</strong> {colors?.roofColor}
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>Interior Roof Color:</strong>{' '}
												{colors?.intRoofColor}
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>Trim Colors:</strong> {colors?.trimColor}
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>Gable Color:</strong> {colors?.gableEndColor}
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>End wall Color:</strong> {colors?.endWallsColor}
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>Side wall Color:</strong>{' '}
												{colors?.sideWallColor}
											</td>
											<td>-</td>
										</tr>

										{/* ============================ 
										<tr>
											<th className="title-tr">COMPONENTS</th>
										</tr>
										<tr>
											<th className="title-tr">OPTIONS</th>
										</tr>
										*/}

										{doorWindowSelections &&
											doorWindowSelections.some((selection) =>
												[37, 36, 34, 33, 38, 15].includes(selection.categoryId)
											) && (
												<>
													<tr>
														<th className="title-tr">DOORS & WINDOWS</th>
													</tr>

													{doorWindowSelections.map((selection, index) =>
														[37, 36, 34, 33, 38, 15].includes(
															selection.categoryId
														) ? (
															<React.Fragment key={index}>
																<tr>
																	<td>
																		<strong>Description:</strong>{' '}
																		<strong>
																			{{
																				37: 'Vents',
																				36: 'Walk-in Door',
																				34: 'Rollup Door',
																				33: 'Frameouts',
																				15: 'Window',
																				38: 'Skylight',
																			}[selection.categoryId] ||
																				selection.categoryId}
																		</strong>{' '}
																		{selection.description}
																	</td>
																	<td>
																		{typeof selection.defaultPrice === 'object'
																			? new Intl.NumberFormat('en-US', {
																					style: 'currency',
																					currency: 'USD',
																			  }).format(selection.defaultPrice.value)
																			: new Intl.NumberFormat('en-US', {
																					style: 'currency',
																					currency: 'USD',
																			  }).format(selection.defaultPrice)}
																	</td>
																</tr>
																<tr>
																	<td>
																		<strong>Section:</strong>{' '}
																		{selection.metadata.section ===
																			'rightLeanTo' && 'Right Lean-to'}
																		{selection.metadata.section ===
																			'leftLeanTo' && 'Left Lean-to'}
																		{selection.metadata.section ===
																			'backLeanTo' && 'Back Lean-to'}
																		{selection.metadata.section ===
																			'frontLeanTo' && 'Front Lean-to'}
																		{selection.metadata.section ===
																			'centerSection' && 'Center Section'}
																	</td>
																	<td>&nbsp;</td>
																</tr>
																<tr>
																	<td colSpan="2">
																		<strong>Location:</strong>{' '}
																		{selection.metadata.buildingSides} Left ={' '}
																		{selection.metadata.locationLeft}ft, Bottom
																		={selection.metadata.locationBottom}ft
																	</td>
																</tr>
																<tr>
																	<td>&nbsp;</td> <td>&nbsp;</td>
																</tr>
															</React.Fragment>
														) : null
													)}
												</>
											)}

										{/* ============================ */}
										{/* Additional options */}
										<tr>
											<th className="title-tr">ADDITIONAL OPTIONS</th>
										</tr>
										<tr>
											<td>
												<strong>Side Wall Siding Panels:</strong>{' '}
												{formAdditionalOptionsData?.sidewall}
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>Gable End Siding Panels:</strong>{' '}
												{formAdditionalOptionsData?.gableEndSidingPanels}
											</td>
											<td>-</td>
										</tr>
										<tr>
											<td>
												<strong>Frame Gauge:</strong>{' '}
												{formAdditionalOptionsData?.frameGauge === '2' ? '12-Gauge' : '14-Gauge'}
											</td>
											<td>-</td>
										</tr>
										{formAdditionalOptionsData?.panelUpgrade && formAdditionalOptionsData.panelUpgrade !== 'standardPanel29Gauge' && (
											<tr>
												<td>
													<strong>Panel Upgrade:</strong>{' '}
													{formAdditionalOptionsData.panelUpgrade === '26GaugePanelUpgrade' ? '26-Gauge Panel' : 'Colored Screws'}
												</td>
												<td>{formatPrice(panelUpgradePrice)}</td>
											</tr>
										)}
										{autoBracingCount > 0 && (
											<tr>
												<td>
													<strong>Diagonal Bracing:</strong>{' '}
													{autoBracingCount} unit(s)
												</td>
												<td>{formatPrice(autoBracingTotalPrice)}</td>
											</tr>
										)}
										{formAdditionalOptionsData?.aditionalBracing && formAdditionalOptionsData.aditionalBracing !== 'none' && (
											<tr>
												<td>
													<strong>Additional Bracing:</strong>{' '}
													{formAdditionalOptionsData.aditionalBracing} unit(s)
												</td>
												<td>{formatPrice(bracingTotalPrice)}</td>
											</tr>
										)}
										{formAdditionalOptionsData?.anchors && formAdditionalOptionsData.anchors !== 'none' && (
											<tr>
												<td>
													<strong>Anchors:</strong>{' '}
													{formAdditionalOptionsData.anchors} unit(s)
												</td>
												<td>{formatPrice(anchorsTotalPrice)}</td>
											</tr>
										)}
										{trussesTotalPrice > 0 && (
											<tr>
												<td>
													<strong>Trusses:</strong>{' '}
													{[
														formAdditionalOptionsData?.trussesCS && `Center ×${formAdditionalOptionsData.trussesCS}`,
														formAdditionalOptionsData?.trussesLS && `Left ×${formAdditionalOptionsData.trussesLS}`,
														formAdditionalOptionsData?.trussesRS && `Right ×${formAdditionalOptionsData.trussesRS}`,
														formAdditionalOptionsData?.trussesFS && `Front ×${formAdditionalOptionsData.trussesFS}`,
														formAdditionalOptionsData?.trussesBS && `Back ×${formAdditionalOptionsData.trussesBS}`,
													].filter(Boolean).join(', ')}
												</td>
												<td>{formatPrice(trussesTotalPrice)}</td>
											</tr>
										)}
										{texasCutTotal > 0 && (
											<tr>
												<td><strong>Texas Cut</strong></td>
												<td>{formatPrice(texasCutTotal)}</td>
											</tr>
										)}
										{foamClosureTotal > 0 && (
											<tr>
												<td><strong>Foam Closure</strong></td>
												<td>{formatPrice(foamClosureTotal)}</td>
											</tr>
										)}
										{/* Insulation Options */}
                                        {/* Center Section */}
										{formAdditionalOptionsData?.roofInsulationCS && (
											<tr>
												<td>
													<strong>Center Roof Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.roofInsulationCS)}</td>
											</tr>
										)}
                                        {formAdditionalOptionsData?.backInsulationCS && (
											<tr>
												<td>
													<strong>Center Back Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.backInsulationCS)}</td>
											</tr>
										)}
                                        {formAdditionalOptionsData?.frontInsulationCS && (
											<tr>
												<td>
													<strong>Center Front Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.frontInsulationCS)}</td>
											</tr>
										)}
                                        {formAdditionalOptionsData?.leftInsulationCS && (
											<tr>
												<td>
													<strong>Center Left Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.leftInsulationCS)}</td>
											</tr>
										)}
                                        {formAdditionalOptionsData?.rightInsulationCS && (
											<tr>
												<td>
													<strong>Center Right Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.rightInsulationCS)}</td>
											</tr>
										)}

                                        {/* Left Lean-to */}
										{formAdditionalOptionsData?.roofInsulationLS && (
											<tr>
												<td>
													<strong>Left Lean-to Roof Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.roofInsulationLS)}</td>
											</tr>
										)}
                                         {formAdditionalOptionsData?.backInsulationLS && (
											<tr>
												<td>
													<strong>Left Lean-to Back Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.backInsulationLS)}</td>
											</tr>
										)}
                                         {formAdditionalOptionsData?.frontInsulationLS && (
											<tr>
												<td>
													<strong>Left Lean-to Front Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.frontInsulationLS)}</td>
											</tr>
										)}
                                         {formAdditionalOptionsData?.leftInsulationLS && (
											<tr>
												<td>
													<strong>Left Lean-to Side Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.leftInsulationLS)}</td>
											</tr>
										)}

                                        {/* Right Lean-to */}
										{formAdditionalOptionsData?.roofInsulationRS && (
											<tr>
												<td>
													<strong>Right Lean-to Roof Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.roofInsulationRS)}</td>
											</tr>
										)}
                                        {formAdditionalOptionsData?.backInsulationRS && (
											<tr>
												<td>
													<strong>Right Lean-to Back Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.backInsulationRS)}</td>
											</tr>
										)}
                                        {formAdditionalOptionsData?.frontInsulationRS && (
											<tr>
												<td>
													<strong>Right Lean-to Front Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.frontInsulationRS)}</td>
											</tr>
										)}
                                        {formAdditionalOptionsData?.rightInsulationRS && (
											<tr>
												<td>
													<strong>Right Lean-to Side Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.rightInsulationRS)}</td>
											</tr>
										)}

                                        {/* Front Lean-to */}
                                        {formAdditionalOptionsData?.roofInsulationFS && (
											<tr>
												<td>
													<strong>Front Lean-to Roof Insulation:</strong> Yes
												</td>
												<td>{formatPrice(insulationPriceBreakdown?.roofInsulationFS)}</td>
											</tr>
										)}

										{/* ============================ */}
										{totalLegPrice ? (
											<tr>
												<td>
													<strong>Leg Height:</strong> {cSHeight}‘H
												</td>
												<td>
													$
													{totalLegPrice?.toLocaleString('en-US', {
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													})}
												</td>
											</tr>
										) : (
											''
										)}
									</tbody>
								</table>

								<div className="price-total-container">
									{totalDiscount && (
										<div className="price-total">
											<p className="price-total-title">Discount:</p>
											<p className="price-total-value">
												-$
												{totalDiscount?.toLocaleString('en-US', {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												})}
											</p>
										</div>
									)}
									<div className="price-total">
										<p className="price-total-title">Subtotal:</p>
										<p className="price-total-value">
											$
											{subTotal?.toLocaleString('en-US', {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})}
										</p>
									</div>
									<div className="price-total">
										<p className="price-total-title">Engineering Quote:</p>
										<p className="price-total-value">
											{engineeringPlansFee > 0
												? `$${engineeringPlansFee.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
												: '$0.00'}
										</p>
									</div>
									<div className="price-total">
										<p className="price-total-title">Return:</p>
										<p className="price-total-value">$0.00</p>
									</div>
									<div className="price-total">
										<p className="price-total-title">Labor:</p>
										<p className="price-total-value">$0.00</p>
									</div>
									<div className="price-total">
										<p className="price-total-title">Equipment:</p>
										<p className="price-total-value">$0.00</p>
									</div>
									<div className="price-total">
										<p className="price-total-title">Freight:</p>
										<p className="price-total-value">$0.00</p>
									</div>

									<div className="price-total">
										<p className="price-total-title">
											Sales Tax ({taxRateDisplay}%):
										</p>
										<p className="price-total-value">${taxes?.toFixed(2)}</p>
									</div>
									<div className="price-total grand-total">
										<p className="price-total-title">
											Total:
										</p>
										<p className="price-total-value">
											$
											{total?.toLocaleString('en-US', {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})}
										</p>
									</div>
									<div className="price-total">
										<p className="price-total-title">Deposit Amount (10%):</p>
										<p className="price-total-value">
											${(total * 0.1).toFixed(2)}
										</p>
									</div>
									<div className="price-total">
										<p className="price-total-title">Due Upon Delivery:</p>
										<p className="price-total-value">
											$
											{(total - total * 0.1).toLocaleString('en-US', {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})}
										</p>
									</div>
								</div>
							</div>
						)}
					</>
				</div>
			</div>
		</div>
	);
}
